import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private matSnackbar: MatSnackBar) {}

  openSnackBar(message: string, action?: string) {
    this.matSnackbar.open(message, action, {
      duration: 3000,
      panelClass: ['custom-snack-bar']
    });
  }
}
